import type { Root } from 'mdast';
import type { Node, Parent } from 'unist';

// Marks a paragraph that directly follows another paragraph, so the renderer
// can add the 12px gap between consecutive paragraphs.
export default function remarkSpacedParagraphs() {
  return (tree: Root) => {
    markSpaced(tree);
  };
}

function markSpaced(node: Parent): void {
  node.children.forEach((child, index) => {
    if (child.type === 'paragraph') {
      const previous = node.children[index - 1];

      if (previous?.type === 'paragraph') {
        child.data = { ...child.data, hProperties: { 'data-spaced': 'true' } };
      }
    }

    if (isParent(child)) {
      markSpaced(child);
    }
  });
}

function isParent(node: Node): node is Parent {
  return 'children' in node;
}
